import { createFileRoute } from '@tanstack/react-router';

import { RequireAuth } from '../features/auth/require-auth.js';
import { AppShell } from '../features/shell/app-shell.js';

/** Pathless layout: auth gate → app shell around every authenticated route. */
export const Route = createFileRoute('/_authed')({
  component: () => (
    <RequireAuth>
      <AppShell />
    </RequireAuth>
  ),
});
